//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        agree: {
            type: Boolean,
        }
    },
    methods: {
        confirm () {
            if (this.agree) {
                this.$emit('confirm')
                this.hide()
            }
        },
        toggleAgree () {
            this.$emit('toggleAgree')
        },
        hide () {
            this.$emit('hide')
        }
    }
}
